export default __webpack_public_path__ + "static/preview_300x620_H264-6502de79524926808a46a58bcb8139c2.mp4";